import { useQuery } from '@tanstack/react-query'

import { getKeywordSuggestions } from '../api/getKeywordSuggestions'

import type { GapKeyword } from '@pepper/utils/src/types/seo'

type ReturnType = {
  data: GapKeyword[] | undefined
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: Error | null
}

const STALE_TIME_MS = 300000 // 5mins
export const useGetKeywordSuggestions = ({
  companyId,
  reportId,
  enabled = false,
}: {
  companyId: string
  reportId: string
  enabled?: boolean
}): ReturnType => {
  const handleApiRequest = async () => {
    const response = await getKeywordSuggestions({
      companyId,
      reportId,
    })
    if (response.status === 'error') {
      throw new Error(response.error)
    }
    return response?.data
  }

  const { isLoading, isFetching, isError, error, refetch, data } = useQuery<
    GapKeyword[],
    Error
  >({
    queryKey: ['content-gap-keyword-suggestions', companyId, reportId],
    queryFn: handleApiRequest,
    enabled,
    retry: 3,
    cacheTime: STALE_TIME_MS,
  })

  return {
    data,
    isLoading,
    isFetching,
    refetch,
    error,
  }
}
